import PageHeader from "src/components/PageHeader";

export default function Categories() {
  return (
    <PageHeader
      title="مدیریت دسته‌بندی محصولات"
    />
  )
}
